import { render } from "./Annonces.vue?vue&type=template&id=2c2a493d"
import script from "./Annonces.vue?vue&type=script&lang=js"
export * from "./Annonces.vue?vue&type=script&lang=js"

import "../Pages-annonces/Annonces.vue?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__